import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from './select/select.component';
import { DialogComponent } from './dialog/dialog.component';
import { DialogService } from './dialog/dialog.service';
import { DialogDirective } from './dialog/dialog.directive';
import { BasicDialogComponent } from './dialog/presets/basic-dialog.component';
import { PopoverComponent } from './popover/popover.component';
import { PopoverDirective } from './popover/popover.directive';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { PaginatorComponent } from './paginator/paginator.component';
import { RadioComponent } from './radio/radio.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { DateFilterComponent } from './date-filter/date-filter.component';
import { SortListComponent } from './sort-list/sort-list.component';

@NgModule({
    declarations: [
        TooltipComponent,
        TooltipDirective,
        PopoverComponent,
        PopoverDirective,
        SelectComponent,
        DialogComponent,
        DialogDirective,
        BasicDialogComponent,
        PaginatorComponent,
        RadioComponent,
        ToolbarComponent,
        DateFilterComponent,
        SortListComponent
    ],
    providers: [
        DialogService
    ],
    exports: [
        TooltipComponent,
        TooltipDirective,
        PopoverComponent,
        PopoverDirective,
        SelectComponent,
        DialogComponent,
        BasicDialogComponent,
        PaginatorComponent,
        RadioComponent,
        ToolbarComponent,
        DateFilterComponent,
        SortListComponent    
    ],
    imports: [
        CommonModule,
        OverlayModule,
        ReactiveFormsModule
    ]
})
export class UiModule { }
